export var ReleaseType;
(function (ReleaseType) {
    ReleaseType["All"] = "";
    ReleaseType["Released"] = "released";
    ReleaseType["ComingSoon"] = "coming soon";
})(ReleaseType || (ReleaseType = {}));
